export default {
    title: "AELU",
    ssv: "Tukoy na kasanayan visa",
    what_ssv: "Tukoy na kasanayan visa",
    representative_message: "Mensahe ng kinatawan",
    aeru_feature: "Mga tampok ng AELU",
    aeru_how_to_use: "Daloy ng paggamit",
    aeru_q_a: "Q & A",
    aeru_function: "Mga pagpapaandar ng AELU",
    aeru_fee: "Singil ng AELU",
    login: "Mag log in",
    db_top_comment1: "Una sa industriya! Ang site ng pagsasanay sa online na smartphone para sa Tiyak na kasanayan sa Visa Examination.",
    db_top_comment2: "Ang AELU ay isang serbisyo sa web na sumusuporta sa pagkuha ng mga partikular na kasanayan na visa sa pamamagitan ng pag-aaral para sa mga pagsusulit, impormasyon sa pagsusulit, at ahensya ng aplikasyon.",
    db_top_pr: "Gamitin ang iyong Tiyak na Kasanayan Visa upang sakupin ang mga bagong pagkakataon.",
    member_regist: "Rehistro ng miyembro",
    registration_support_organization: "Ano ang isang samahan ng suporta sa pagpaparehistro?",
    rso_dec1: "Mayroong dalawang mga samahan sa tukoy na sistema ng kasanayan, ang tukoy na kaakibat na samahan at ang samahan ng suporta sa pagpaparehistro. Ang isang tukoy na samahan ng kaakibat na kasanayan ay isang kumpanya (tumatanggap ng samahan) na gumagamit ng mga dayuhan na may mga tiyak na kasanayan. Ang institusyong kinabibilangan ng tiyak na kasanayan ay dapat magbigay ng suporta para sa mga dayuhan na may tiyak na kasanayan sa lugar ng trabaho, pang-araw-araw na buhay, at lipunan.",
    rso_dec2: "Dahil may mga dalubhasang nilalaman sa pagsuporta sa mga dayuhan na may tiyak na mga kasanayan, may mga kaso kung saan mahirap para sa kumpanya na gumagamit ng mga dayuhan na may mga tiyak na kasanayan, ang institusyon kung saan kabilang ang mga partikular na kasanayan, upang magbigay ng suporta. Ang isang samahan ng suporta sa pagpaparehistro ay isang samahan na ipinagkatiwala sa isang tukoy na samahan na kaakibat ng kasanayan upang lumikha at magpatupad ng isang plano sa suporta para sa mga dayuhan na may mga tiyak na kasanayan.",
    rso_dec3: "Ang isang samahan ng suporta sa pagpaparehistro ay isang samahan na ipinagkatiwala sa isang tukoy na samahan na kaakibat ng kasanayan upang lumikha at magpatupad ng isang plano sa suporta para sa mga dayuhan na may mga tiyak na kasanayan.",
    rso_dec4: "Ang samahan ng suporta sa pagpaparehistro ay magbibigay ng lahat ng suporta batay sa No. 1 Naukoy na Skilled Alien Support Plan sa pamamagitan ng isang kontrata ng consignment ng suporta sa host na samahan.",
    rso_dec5: "○ Upang maging isang samahan ng suporta sa pagpaparehistro, kailangan mong irehistro ng Komisyonado ng Immigration Bureau ng Japan.",
    rso_dec6: "○ Ang mga rehistradong institusyon ay ipaparehistro sa rehistro ng samahan ng suporta sa pagpaparehistro at mai-post sa website ng Immigration Bureau ng Japan.",
    rso_dec7: "○ Ang panahon ng pagpaparehistro ay 5 taon at kailangang i-renew.",
    rso_dec8: "○ Ang mga organisasyon ng suporta sa pagpaparehistro ay kinakailangang magsumite ng iba&#39;t ibang mga abiso sa Immigration Bureau ng Japan sa anumang oras.",
    article1: "Ano ang isang tiyak na kasanayan visa?",
    article1_dec1: "Sa pagpapatupad ng binagong Batas sa Pagkontrol sa Imigrasyon noong Disyembre 8, 2018, ang katayuan ng paninirahan sa Mga Tiyak na Kasanayan ay bagong itinatag. Ipinatupad noong Abril 2019.",
    article1_dec2: "Ang isang bagong katayuan ng paninirahan Mga Tiyak na Kasanayan ay maitatatag sa dalawang yugto. (Hindi. 1 at Blg. 2)",
    article1_dec3: "Ang mga target na industriya ay 14 na industriya.,",
    article1_dec4: "Ang target na kinakailangan ng mga dayuhan ay isang tao na may mga kasanayan na nangangailangan ng malaking kaalaman o karanasan. Sa madaling salita, ang mga nakatapos ng tatlong taon ng pagsasanay sa pagsasanay sa teknikal o ang mga nakapasa sa katumbas na pagsubok sa wikang Hapon at kasanayan ay karapat-dapat.",
    article1_dec5: "Ang Tiyak na Kasanayan Blg. 1 ay pinapayagan na manatili ng hanggang sa 5 taon bilang isang tao na may ilang mga kasanayan. Hindi pinapayagan ang mga miyembro ng pamilya.",
    article1_dec6: "Bilang isang taong may mga kasanayang may kasanayan, ang Tiyak na Kasanayan No. permanenteng, at maaari mong dalhin ang iyong pamilya.),",
    article2: "Mensahe ng kinatawan",
    article2_sub1: "Huwag talikuran ang Japan",
    article2_dec1: "Nais naming ipahayag ang aming taos-pusong pasasalamat sa maraming mga teknikal na trainee intern at nagbabalik na mga trainee na dumating sa Japan bilang mga teknikal na trainee ng intern, nakakuha ng mga kasanayan, at walang sinuman na pagsisikap para sa kaunlaran ng kanilang sariling bansa. Sa palagay ko ang hitsura ng pagsasanay para sa kapakanan ng pamilya at para sa sariling bansa, na wala sa Japan ngayon, ay ang orihinal na hitsura ng tao. Habang ako ay kasali sa teknikal na intern na pagsasanay sa negosyo sa mahabang panahon, walang paraan upang makapasok lamang sa bansa gamit ang isang teknikal na intern na trainee visa, at sinasamantala ko ang pagkakataong iyon, matatag na magsanay sa Japan, magbukas ng negosyo sa aking sariling bansa, at ang aking bansa ay umunlad nang malaki nakita ko ng maraming. Gayunpaman, noong Abril 2019, isang visa na Tiyak na Kasanayan Visa ang itinayo, na tumutugon sa pagnanais na tangkilikin ang Japan, na hindi maaaring ganap na malaman sa itinakdang bilang ng mga taon. Inaasahan kong maraming mga dayuhan na bumibisita sa Japan na may mga ambisyon sa likod ng kanilang mga mata, na bihira sa Japan, ay maaaring magkasama na makabuo ng Japan. Higit sa lahat, nais kong magkaroon ng mga tao tulad ng Japan, dagdagan ang bilang ng mga permanenteng residente, at lumikha ng isang lipunan kung saan sila maaaring manirahan nang magkasama.",
    article2_dec2: "Ang Visualization Co., Ltd.",
    article2_dec3: "Pangulo at CEO",
    article2_dec4: "Kazuhiko Horiuchi",
    article3: "Tatlong mga tampok na ibinigay ng AELU",
    article3_sub1: "Nag-aaral para sa mga pagsusulit sa online",
    article3_sub1_dec1: "Ang AELU, na nagbibigay-daan sa iyo upang maghanda para sa tukoy na pagsubok sa kasanayan sa iyong smartphone, ay naghahanda ng mga pseudo-tanong pagkatapos ng 30 mga katanungan sa lahat ng 14 na industriya, kabilang ang mga nakaraang katanungan, at maaari kang magsagawa ng mga hakbang hangga&#39;t gusto mo hanggang sa petsa ng pagsusulit. Kung lumagpas ka sa tinukoy na iskor para sa mga katanungan na na-pop out ng AI, tiyak na makakapasa ka sa pagsusulit!",
    article3_sub2: "Impormasyon sa pagsusulit",
    article3_sub2_dec1: "Ang impormasyon sa pagsubok na napakahirap maintindihan ng mga dayuhang bisita sa Japan ay awtomatikong maidaragdag kapag ang impormasyon sa pagsubok ng napiling industriya ay na-update pagkatapos ng pagpaparehistro, at aabisuhan ang gumagamit.",
    article3_sub3: "Ahensya ng aplikasyon ng pagsusulit",
    article3_sub3_dec1: "Tulad ng impormasyon sa pagsusulit, napakahirap para sa mga dayuhang bisita sa Japan na mag-aplay para sa pagsusulit, at hindi mo rin maaaring kumuha ng pagsusulit nang hindi nakumpleto ang online na pamamaraan. Kapag nagparehistro ka, maaari mong mai-post ang impormasyon, mayroon nang form ng aplikasyon, at mag-apply kasabay ng anunsyo ng pagsubok.",
    article4: "Pag-andar ng pagpapakilala pagkatapos pumasa sa pagsubok",
    article4_sub1: "Binabati kita sa mga matagumpay na aplikante \n Cash back (domestic o international)",
    article4_sub1_dec1: "Kung nakatira ka na sa Japan at pumasa gamit ang AELU at i-upload ang numero ng pass at ipasa ang sertipiko sa iyong screen ng gumagamit, maaari kang makakuha ng cash sa parehong araw. Plano ng cash back Product: Online Gift Certificate (Amazon Gift Certificate Email) Uri, Googleplay, iTunes card ng regalo) 5000 yen na nagkakahalaga ng cash pabalik mula sa opisyal na account sa LINE.",
    article4_sub2: "Kampanya ng sanggunian-isang-kaibigan",
    article4_sub2_dec1: "Anyayahan ang mga aplikante sa Japan sa Japan na nasa Japan o sa ibang bansa na sumali sa FB group, sasabihin ng gumagamit ang numero ng pamamahala ng kanyang sarili at ibalik ang pera sa taong nauugnay sa numerong iyon, at 1000 sertipiko ng regalo sa online ang ibibigay sa nagpapakilala. buwan pagkatapos sumali. Yen cash back.",
    article4_sub3: "Matapos makakuha ng isang visa, ang paghahanap ng trabaho ay \n Ai awtomatikong pagtutugma (hindi napagpasyahan)",
    article4_sub3_dec1: "Matapos makapasa sa pagsusulit sa sertipikasyon gamit ang AELU, i-upload ang pass number at ipasa ang sertipiko sa screen ng gumagamit, at makakatanggap ka ng mga awtomatikong alok mula sa lahat ng mga kumpanya sa Japan. Ang mga pakikipanayam ay isasagawa din sa online, at magagawa mong makapasok sa bansa, lumipat, at makakuha ng trabaho na may kapayapaan ng isip sa pamamagitan ng pagkonekta sa online kahit na sa paunang impormal na kabanata!",
    article4_sub4: "Regular na tseke ng kard ng paninirahan \n Cash back (undecided),",
    article4_sub4_dec1: "Kung susuriin mo ang iyong kard ng paninirahan isang beses sa isang buwan nang walang aer sa application ng tseke ng kard ng paninirahan ng Isang Suriing Tab, makakakuha ka ng 10,000 yen cash sa isang taon.,",
    article5: "Tiyak na pagpapakilala ng pagpapaandar,",
    article5_sub1: "Maaari mong tingnan ang problemang nalutas mo",
    article5_sub1_dec1: "Maaari mong maipon ang mga nilalaman ng pagsusulit na iyong sinanay sa online at gamitin ang iyong sariling mga tool upang maunawaan ang mga gawi ng mga gumagamit at mapagtagumpayan ang mga problema na hindi ka mahusay. Dahil maaari kang maghanda para sa pagsubok nang maraming beses hangga&#39;t gusto mo, itala ang lahat ng kasaysayan ng iskor at oras ng pagsubok, at gawin itong mas malapit hangga&#39;t maaari sa aktwal na araw ng pagsubok. Bilang karagdagan, maaari mong maunawaan ang tanong nang mas mahusay dahil nakasulat ito sa iyong sariling wika at Japanese.",
    article5_sub2: "Permanenteng i-save ang iyong resume sa oras ng pagpasok",
    article5_sub2_dec1: "Kapag kumuha ka ng tukoy na pagsubok ng kasanayan sa visa at mag-apply para sa isang visa, kakailanganin mo ang isang resume kapag pumasok ka sa Japan bilang isang teknikal na trainee ng intern. Orihinal na nakaimbak ng isang samahang pamamahala (kooperatiba) o pagpapadala ng samahan, maaari mo itong iimbak nang mag-isa pagkatapos makakuha ng isang tukoy na kasanayan sa visa.",
    article5_sub3: "Pag-andar ng pagpaparehistro ng iyong bansa at larangan,",
    article5_sub3_dec1: "Dahil ang wika ng iyong sariling bansa at Japan ay ginamit nang magkasama, maaari mong maunawaan nang mabuti ang mga katanungan at kumuha ng mga countermeasure. Sa orihinal na pagsusulit, Japanese lang ang magagamit, kaya makakapagsagawa ka lang ng mga hakbang sa Japanese.,",
    article5_sub4: "Mga paalala ng mga kinakailangan sa pagpapatunay ng sertipikasyon at impormasyon",
    article5_sub4_dec1: "Kapag ang iskedyul ng pagsubok para sa nais na trabaho ay na-upload sa HP ng bawat pangkat ng pagsubok, awtomatiko itong mapapaalalahanan, aabisuhan ang gumagamit, ang petsa ng pagsubok ay itatakda sa screen ng gumagamit, at awtomatikong gagana ang timer.",
    article5_sub5: "Pag-aaral gamit ang screening",
    article5_sub5_dec1: "Maaari mong makuha ang mahinang mga puntos ng gumagamit at maghanda para sa pagsusulit.",
    article5_sub6: "Mga konsultasyon sa online na pag-aaral at pakikipanayam gamit ang mga camera ng smartphone.",
    article5_sub6_dec1: "Habang nagpapatuloy sa paghahanda ng pagsusulit gamit ang Aer, malilinaw mo ang kahulugan at hangarin ng tanong sa anyo ng mga online call at chat. Maaaring hindi kinakailangan para sa mga taong sanay sa Japan o na pamilyar dito, ngunit ang pangunahing serbisyo sa konsultasyon sa tawag ay ang pinaka nakakatiyak na paraan upang suriin ang anumang mga alalahanin bago ang pagsusulit!",
    article6: "Bayarin",
    article6_sub1: "Bayad sa paggamit ng AELU",
    article6_sub1_dec1: "Maaari kang mag-aral para sa tukoy na pagsubok ng kasanayan visa nang walang anumang mga paghihigpit. Maaari kang kumunsulta sa online sa iyong katutubong wika. * Maaari mo ring gamitin ito bilang isang interpreter sa normal na oras. \n Posible ang anunsyo sa site ng pagsubok sa araw ng pagsubok. \n Ang pagpapatuloy sa pagpasok ay maaaring mai-save magpakailanman. \n Pagkatapos makapasa sa pagsusulit, irehistro lamang ang iyong tukoy na numero ng pass ng kasanayan sa visa upang ipakilala ang iyong ninanais na trabaho. (Hindi mapagpasya).",
    article6_sub2: "Ahensya ng aplikasyon ng pagsusulit",
    article6_sub2_dec1: "Hindi ka maaaring mag-apply habang nagtatrabaho, at hindi ka makakakuha ng pagsusulit sa sertipikasyon maliban kung mag-apply ka, kaya agad kaming mag-a-apply kapag magagamit ang impormasyon sa pagsusulit sa sertipikasyon upang hindi mo mapalampas ang petsa ng pagsusulit.",
    article7: "Isinasagawa ang kampanya sa cashback!",
    article7_dec1: "Mula sa mga nakapasa sa pagsusulit, ang mga nagparehistro ng numero ng visa para sa serbisyong ito ay makakatanggap ng cashback na 5,000 \n yen! Mag-click dito para sa kung paano makilahok sa kampanya.",
    article8: "Hinahayaan ka na ngayong magparehistro sa AELU!",
    dashboard: "Dashboard",
    member_info: "Pagrehistro ng impormasyon sa profile",
    first_name: "Pangalan",
    midle_name: "Gitnang pangalan",
    family_name: "Apelyido",
    half_width_Roman: "Romaji na kalahating lapad",
    password: "password",
    password_confirm: "Pagkumpirma ng password",
    mail_adress: "mail address",
    lineId: "LINE ID",
    country_id: "Code ng bansa",
    phone: "numero ng telepono",
    issuing_country: "Piliin ang bansa / rehiyon ng paglabas ng ID card",
    IDtype: "Pagpili ng uri ng ID",
    residence_card: "Residence card o ID card",
    passport: "pasaporte",
    regist: "Pagpaparehistro",
    is_required: "Ay sapilitan",
    sign_up: "mag-sign up",
    residence_front: "Sa itaas na pag-upload",
    residence_back: "Mag-upload sa likod",
    passport_upload: "I-upload ang iyong pasaporte",
    error_file: "Mangyaring i-upload ang imahe",
    post_resume: "Magsumite ng resume",
    resume_upload: "Mag-upload ng Resume",
    click_upload: "Mag-click upang i-upload",
    image_drop: "O i-drag at i-drop ang file ng imahe",
    select_language: "Pagpili ng katutubong wika",
    vietnamese: "Vietnamese",
    chinese: "Intsik",
    english: "Ingles",
    khmer: "Khmer",
    indonesian: "Indonesian",
    tagalog: "Tagalog",
    burmese: "Burmese",
    hindu: "Hindu",
    lao: "Lao",
    mongolian: "Mongolian",
    bengali: "Bengali",
    sinhala: "Sinhala",
    banglodesh: "Bangladeshi",
    malay: "Malay",
    nepali: "Nepali",
    thai: "Thai",
    japanese: "Japanese",
    error_lang: "Mangyaring piliin ang iyong katutubong wika.",
    select_ouccupation: "Pagpili ng uri ng trabaho",
    select_max_three: "Maaari kang pumili ng hanggang sa tatlo.",
    industry_id_1: "Pang-matagalang industriya ng pangangalaga",
    industry_id_2: "Negosyo sa paglilinis ng gusali",
    industry_id_3: "Industriya ng hilaw na materyal",
    industry_id_4: "Industriya ng industriya ng paggawa ng makinarya",
    industry_id_5: "Mga industriya na nauugnay sa elektrisidad at elektronikong impormasyon",
    industry_id_6: "Industriya ng konstruksyon",
    industry_id_7: "Shipbuilding / industriya ng dagat",
    industry_id_8: "Industriya ng pagpapanatili ng kotse",
    industry_id_9: "Industriyang panghimpapawid",
    industry_id_10: "Negosyo sa tirahan",
    industry_id_11: "Agrikultura",
    industry_id_12: "Pangisdaan",
    industry_id_13: "Paggawa ng pagkain at inumin",
    industry_id_14: "Negosyo sa restawran",
    industry_id_15: "Raw Material, Industrial Machinery, and Electrical/Electronic Information-related Manufacturing Industry",
    industry: "Industriya",
    error_occupation: "Mangyaring pumili ng isa o higit pang mga uri ng trabaho.",
    do: "Gagawin",
    news_tpic: "balita",
    days_until_exam: "Mga natitirang araw hanggang sa pagsusulit",
    estimated_pass_rate: "Tinantyang rate ng pass",
    average_score_taken: "Average na iskor ng pagsubok na kinuha",
    exam: "Ang pagsusulit ay",
    let_aim: "Hinahayaan nating hangarin",
    score: "punto",
    solve_problem: "Lutasin ang tanong",
    recommend_problem: "Inirekumendang tanong ng AELU",
    solved_problem: "Nalutas ang tanong sa nakaraan",
    looking_solved: "Suriin ang nakaraang mga katanungan",
    consultaion_service: "Pag-aaral ng serbisyo sa konsulta",
    application_agency: "Serbisyo ng ahensya ng aplikasyon ng pagsusulit",
    billing: "Pagsingil",
    more_look: "Suriin pa",
    more_look2: "Suriin pa",
    facebook: "Facebook",
    google: "Google",
    until_not_account: "Kung wala ka pang account",
    or: "o",
    other_way: "Sa ibang paraan",
    not_have_account: "Kung wala kang account",
    have_account: "Kung mayroon kang isang account",
    forgot_password: "Kung nakalimutan mo ang iyong password",
    this: "Dito",
    at_login: "Mag-login kasama si",
    pass_condition: "8 o higit pang mga solong byte alphanumeric na malalaking titik",
    at_sign_up: "Bagong pagpaparehistro sa",
    agreement1: "Sa pamamagitan ng pagsang-ayon sa sumusunod at pagpili na magpatuloy, AELU",
    terms: "Panuntunan ng serbisyo",
    agreement2: "Sumasang-ayon ako sa iyo.",
    agree: "Sumang-ayon at magpatuloy",
    account_confirm: "Code ng kumpirmasyon",
    confirm: "Pagkumpirma",
    not_confirm: "Ang kumpirmasyon code ay hindi nakumpirma.",
    move_confiirm: "Lumilipat sa screen ng pag-input ng code ng kumpirmasyon",
    top: "Tuktok",
    news_list: "listahan ng balita",
    problim_list: "Listahan ng tanong",
    learning_consul: "Pag-aaral ng konsulta",
    agency: "Impormasyon sa pagsusulit",
    of_trend: "Tungkol sa trend ng pagsubok",
    start_test: "Simulan ang pagsubok",
    study_mode: "Mode ng pagkatuto",
    order_question: "Tanong",
    of_question: "Sa tanong",
    question_current: "Tanong ng tamang sagot",
    to_mypage: "sa Aking pahina",
    correct_answer: "Tamang sagot!",
    correct_answer_normal: "Tamang sagot",
    no_correct_answer: "Maling sagot",
    next: "Sa susunod na tanong",
    finish_all: "Sinagot ang lahat ng mga katanungan!",
    your_score: "Ang iyong iskor ay",
    is: "ay!",
    result_description: "Maaari mong malutas ang iba pang mga katanungan mula sa listahan ng Tingnan ang mga katanungan. Maaari mo ring balikan ang mga tanong na nalutas mo sa nakaraan mula sa pahina ng listahan ng mga katanungan.",
    back_quiz_list: "Suriin ang listahan ng mga katanungan",
    retry: "Malutas ulit ang mga katanungang ito",
    no_description: "Walang paliwanag",
    show_ans: "Suriin ang sagot",
    of_solved_problem: "Nalutas ang tanong sa nakaraan",
    of_solved_problem_list: "Listahan ng mga katanungan na nalutas sa nakaraan",
    solved_description: "Maaari mong suriin muli ang pagsubok sa pag-aaral para sa tukoy na pagsubok ng kasanayan visa ng pangmatagalang industriya ng pangangalaga.",
    before_result: "Mga nakaraang resulta",
    looking_back: "suriin ulit",
    back_solved_problem_list: "Suriin ang isang listahan ng mga katanungan na nalutas sa nakaraan",
    again_retry: "Sa pagbabalik tanaw sa katanungang ito muli",
    done_member_regist: "Salamat sa pagrehistro bilang isang miyembro!",
    done_member_regist_description: "Magagamit ang bawat serbisyo pagkatapos mong bayaran ang bayarin sa paggamit ng serbisyo. \n Mangyaring iparehistro ang iyong impormasyon sa pagbabayad.",
    choose_payment: "Pumili ng paraan ng pagbabayad",
    service_content: "Mga nilalaman ng serbisyo",
    test_info_service: "Serbisyo ng impormasyon sa pagsusulit",
    usage_fee: "bayad sa paggamit",
    test_fee: "500 yen + buwis",
    application_fee: "20000 yen + buwis",
    method_payment: "paraan ng Pagbayad",
    LINE_pay: "LINE Pay",
    line_pay_description: "* Mangyaring i-save ang imahe ng QR code at magbayad sa loob ng serbisyo sa LINE Pay. Kapag nagbabayad gamit ang LINE Pay magtatagal bago makumpirma ng pamamahala.",
    save_qr: "I-save ang QR code",
    next_stage: "susunod na",
    credit_card: "credit card",
    copmplete_payment: "Kumpleto na ang bayad.",
    copmplete_payment_descript: "Ngayong nakumpleto na ang pagbabayad, maaari mong gamitin ang pagpapaandar sa pag-aaral sa online na pagsusulit, impormasyon sa pagsusulit, at serbisyo sa ahensya ng aplikasyon ng pagsusulit.",
    start_sevice: "Simulang gamitin ang serbisyo",
    to_payment: "Sa screen ng pagbabayad",
    of_news_list: "listahan ng balita",
    done_payment: "Nakumpleto na ang bayad.",
    tv_consult: "Konsulta sa videophone",
    tell_consult: "Konsulta sa telepono",
    learning_consul_descript01: "Application ng pagsusulit",
    learning_consul_descript02: "Kumikilos kami para sa iyong ngalan",
    money_unit: "JPY",
    learning_consul_unit: "Minsan",
    fault_payment1: "Nabigo ang pagbabayad.",
    fault_payment2: "Pakiulit muli.",
    no_examination: "Hindi pa",
    no_exam: "Wala pa exam",
    undecided: "Hindi mapagpasya",
    retry_login: "Mangyaring mag-log in muli",
    no_problem: "Walang solusyon sa pagtanong",
    do_problem: "Lutasin ang tanong",
    qa_title: "Mga Madalas Itanong",
    search_category: "Pakitid ayon sa kategorya",
    search_freeward: "Maghanap sa pamamagitan ng libreng salita",
    test_result: "Pagsasanay sa mga resulta sa pagsubok",
    to_top: "Hanggang sa taas",
    missPassword: "Maling password o email address",
    sample_problem: "Karanasan sa pag-aaral para sa isang online na pagsusulit",
    exercises: "Ehersisyo",
    let_exercises: "Malutas lamang natin ang isang totoong problema!",
    to_qa: "Suriin pa ang Q&A",
    read_more: "Suriin pa",
    account_setting: "Pagtatakda ng Account",
    profile_setting: "Mga setting ng profile",
    notification_setting: "Mga setting ng abiso",
    logout: "Pag-logout",
    changeEmail: "Baguhin ang email address",
    changePassword: "Palitan ANG password",
    change: "magbago",
    save: "magtipid",
    change_success: "Nakumpleto ang pagbabago",
    now_password: "Kasalukuyang password",
    new_password: "bagong password",
    check_new_password: "Bagong password (kumpirmasyon)",
    do_logout: "naka-log out",
    done_learning_consul_payment: "Nakumpleto na ang bayad.",
    past_exam: "Mga nakaraang tanong",
    update_info: "Ina-update ang pinakabagong impormasyon",
    official_sns: "Opisyal na SNS",
    privacy_policy: "patakaran sa privacy",
    terms_service: "Panuntunan ng serbisyo",
    transaction_law: "Notasyon batay sa Natukoy na Batas sa Mga Transaksyon sa Komersyal",
    selectCountry: "Mangyaring pumili ng bansa",
    goInquiry: "Magpatuloy sa pagtatanong",
    lineInquiry: "Makipag-ugnay sa amin sa pamamagitan ng LINE",
    regist_accept_certificate: "Pagrehistro ng tiyak na sertipiko ng pass ng pagkuha ng kasanayan sa visa",
    accept_certificate_description: "Maaari mong irehistro ang iyong sertipiko at numero ng pass",
    accept_certificate: "Sertipiko ng pagtanggap",
    accept_number: "Numero ng pass",
    immigration_resume: "Ipagpatuloy ang pagpaparehistro sa oras ng pagpasok",
    resendCode: "Ipadala muli ang verification code",
    line_at_register: "Mga katanungan sa serbisyo sa pamamagitan ng LINE @",
    study: "Pag-aralan at suriin muli",
    study_text: "Mag-download ng teksto ng pag-aaral",
    do_resume_update: "Mangyaring i-upload ang iyong resume",
    done_resume_update: "Salamat sa pagrehistro ng iyong resume!",
    regist_resume_enter: "Pagrehistro ng resume sa oras ng pagpasok",
    about_company: "Tungkol sa operating company",
    add_exam_info_detail: "Ang impormasyon sa pagsusulit ay naidagdag. Mag-click dito para sa mga detalye at aplikasyon",
    regist_result_get_money: "Irehistro ang iyong mga resulta sa pagsusulit at makuha ang iyong pera",
    detail: "Mga Detalye",
    about_withdrawal_subsc: "Tungkol sa pag-atras at pagkansela ng subscription",
    apply_withdrawal: "Application para sa unsubscription",
    apply_subsc: "Application para sa pag-unsubscribe mula sa subscription",
    about_withdrawal: "Application ng pag-atras",
    about_subsc: "Mag-unsubscribe mula sa subscription",
    exam_info: "Impormasyon sa pagsusulit",
    date: "Petsa at oras",
    day: "Araw",
    place: "lugar",
    result_publication: "resulta ng paglalathala",
    result_publication_place: "Lugar upang ipahayag ang resulta",
    result_this_page: "Ipapahayag sa pahinang ito",
    exam_way: "Format ng pagsusulit",
    exam_way2: "Format ng tanong sa pagsusulit",
    include_exam_fee: "Kasama ang bayad sa pagsubok",
    exam_application_desc: "Pagsumite ng form ng aplikasyon sa pagsusulit. \n Pakikipag-ugnayan sa tanggapan ng pagsusulit \n Pakikipag-ugnay sa kung ano ang ihahanda sa araw (LINE @) \n Konsulta para sa anumang mga katanungan tungkol sa pagsusulit",
    self_application: "Mag-apply nang mag-isa",
    application_method: "Paano mag-apply",
    under_this_url: "Mangyaring kumpletuhin ang pamamaraan ng aplikasyon mula sa sumusunod na URL.",
    do_appliction: "Mag-apply para sa pagsusulit",
    study_with_aeru: "Gamitin ang pagpapaandar sa pag-aaral ng pagsusulit mula sa tuktok na pahina upang madagdagan ang rate ng pass.",
    line_at_consul: "LINE @ pag-aaral ng serbisyo sa konsulta",
    instagram: "Instagram",
    do_signup: "Ikaw ay napatunayan. \n Mangyaring mag-log in muli.",
    gender: "Kasarian",
    man: "Lalaki",
    woman: "Babae",
    input_problem_title: "Naglalaman ng pamagat ng problema ...",
    still_no_problem: "Walang problema",
    enter_in_problem_trend: "Naglalaman ng isang maikling paliwanag ng pagsusulit tulad ng mga uso sa pagsusulit sa ngayon at ang format ng sagot (uri ng pagpili).",
    correct: "Tamang sagot",
    explanation: "Paliwanag",
    problem: "tanong",
    do_nursing_not_published: "Ang pagsusulit ay isinasagawa sa pangmatagalang industriya ng pangangalaga ngunit ang mga nakaraang katanungan ay hindi nai-publish.",
    practical_exam_of_year: "Pagsubok ng praktikal na taon",
    judgment_test_of_year: "2019 Exam ng Paghuhukom",
    judgment_test_answer_of_year: "Sagot sa Pagsusulit sa Paghuhukom 2019",
    not_yet_test_material: "Hindi pa pagsusulit sa industriya ng hilaw na materyal",
    not_yet_test_machinery: "Hindi pa pagsusulit sa sektor ng pagmamanupaktura ng makinarya pang-industriya",
    not_yet_test_electronic: "Hindi pa pagsusulit sa industriya ng elektrikal at elektronikong nauugnay sa impormasyon",
    not_yet_test_construction: "Hindi pa pagsusulit sa industriya ng konstruksyon",
    not_yet_test_shipbuilding: "Hindi pa pagsusulit sa paggawa ng barko at industriya ng dagat",
    do_automobile_not_published: "Ang mga pagsusulit ay isinasagawa sa larangan ng pagpapanatili ng sasakyan ngunit ang mga nakaraang katanungan ay hindi nai-publish.",
    do_aviation_not_published: "Ang mga pagsusulit ay isinasagawa sa industriya ng abyasyon ngunit ang mga nakaraang katanungan ay hindi nai-publish.",
    do_agricultural_not_published: "Ang pagsusulit ay isinasagawa sa sektor ng agrikultura ngunit ang mga nakaraang katanungan ay hindi nai-publish.",
    do_fishery_not_published: "Ang pagsusulit ay isinasagawa sa larangan ng pangisdaan ngunit ang mga nakaraang katanungan ay hindi nai-publish.",
    do_food_not_published: "Isinasagawa ang mga pagsusulit sa industriya ng pagmamanupaktura ng pagkain at inumin ngunit ang naunang mga katanungan ay hindi nai-publish.",
    do_restaurant_not_published: "Ang pagsusulit ay isinasagawa sa industriya ng serbisyo sa pagkain ngunit ang mga nakaraang katanungan ay hindi nai-publish.",
    schedule_undecided: "(* Ang iskedyul ay hindi napagpasyahan)",
    year: "Taon",
    month: "Buwan",
    texts_learning: "Mga aklat para sa pag-aaral ng bawat industriya",
    texts_learning_test: "Tiyak na teksto ng pag-aaral ng pagsusulit sa pagsusuri sa kasanayan (Japanese)",
    skill_test_sample: "Sampol sa pagsusulit sa pagsusuri ng kasanayan",
    japanese_test_sample: "Halimbawa ng pagsusulit sa Pagsusuri sa Hapon",
    not_building_texts: "Wala pang natutunan na libro para sa industriya ng paglilinis ng gusali.",
    not_material_texts: "Wala pang pag-aaral ng aklat para sa industriya ng hilaw na materyal.",
    not_machinery_texts: "Walang pag-aaral ng aklat sa larangan ng paggawa ng makinarya pang-industriya.",
    not_electronic_texts: "Wala pang natututo na aklat para sa mga industriya na may kaugnayan sa elektrisidad at elektronikong impormasyon.",
    not_shipbuilding_texts: "Wala pang libro sa pag-aaral para sa paggawa ng mga bapor / industriya sa dagat.",
    not_automobile_texts: "Wala pang libro sa pag-aaral para sa industriya ng pagpapanatili ng sasakyan.",
    not_accommodation_texts: "Wala pang libro sa pag-aaral para sa industriya ng tirahan.",
    not_food_texts: "Wala pang natututo na libro para sa industriya ng pagmamanupaktura ng pagkain at inumin.",
    not_restaurant_texts: "Aralin sa pagsusulit sa pagsusulit sa kasanayan sa pagsusukat sa serbisyo sa pagkain",
    each_depertment_texts: "Mga aklat para sa pag-aaral ng pagsusulit sa bawat kagawaran",
    skill_test_basic: "Kasanayan sa pagsusuri ng pagsusulit sa teksto ng teksto (pangunahing teknolohiya)",
    skill_test_safety: "Kasanayan sa pag-aaral ng pagsusuri sa teksto ng teksto (kaligtasan / kalidad ng trabaho)",
    skill_test_aircraft: "Kasanayan sa pag-aaral ng pagsusulit sa teksto ng teksto (pangkalahatang-ideya ng sasakyang panghimpapawid)",
    texts_livestock: "[Teksbuk para sa pag-aaral ng pagsasaka ng hayop] bersyon ng Hapon",
    texts_cultivated: "[Teksto para sa pag-aaral ng agrikultura sa pagsasaka] bersyon ng Hapon",
    skill_test_fishery: "Pagsusulit sa pagsusukat ng kasanayan sa pangisdaan (pangisdaan)",
    skill_test_general_fishery: "Pagsusulit sa pagsusukat ng kasanayan sa pangisdaan (pangkalahatang pangisdaan)",
    skill_test_safety_fishery: "Pagsusulit sa pagsusukat ng kasanayan sa pangisdaan (kaligtasan ng pangisdaan)",
    skill_test_specialty_fishery: "Pagsusulit sa pagsusukat ng kasanayan sa pangisdaan (nauugnay sa net na nagdadalubhasang pangisdaan)",
    skill_test_related_fishery: "Pagsusulit sa pagsusukat ng kasanayan sa pangisdaan (nauugnay sa pangingisda sa specialty ng pangisdaan)",
    skill_test_aquaculture: "Pagsusulit sa pagsusukat ng kasanayan sa pangisdaan (aquaculture)",
    skill_test_general_aquaculture: "Pagsusulit sa Pagsukat sa Mga Kasanayan sa Pangisda (Pangkalahatang / Kaligtasan ng Aquaculture)",
    skill_test_feeding_aquaculture: "Pagsusulit sa pagsusukat ng kasanayan sa pangisdaan (pagpapakain at aquaculture)",
    skill_test_non_feeding_aquaculture: "Pagsusulit sa pagsusukat ng kasanayan sa pangisdaan (na may kaugnayan sa hindi nakatuon na aquaculture)",
    registration_skill_visa: "Pagrehistro ng sertipiko ng pagtanggap ng tiyak na kasanayan visa",
    please_register_pdf_number: "Mangyaring iparehistro ang larawan o PDF ng pass sertipiko para sa pagkuha ng isang tukoy na kasanayan visa at ang numero ng pass sa sertipiko ng pass.",
    regist_and_get_cash_bag: "Kung magparehistro ka ngayon, maaari kang makakuha ng 5000 yen na may isang cash bag.",
    thank_you_regist_visa_pass: "Salamat sa pagrehistro ng sertipiko ng pagpasa ng tukoy na kasanayan visa!",
    exam_info_detail: "Balangkas ng pagpapatupad ng pagsusulit",
    em_exam_detail_language: "Naka-iskedyul na gawin sa lokal na wika",
    em_exam_detail_method: "Kagawaran pagsusulit, praktikal na pagsusulit",
    em_exam_detail_way: "Pamamaraan sa pagsubok sa papel na batay sa computer (CBT) na pamamaraan ng pagsubok sa trabaho o pamamaraan ng pagsubok sa trabaho tulad ng paggawa",
    em_exam_detail_section: "19 kategorya ng pagsusuri (casting, forging, die casting, machining, metal stamping, ironwork, factory sheet metal, plating, aluminyo anodization, pagtatapos, inspeksyon ng makina, pagpapanatili ng makina, elektronikong pagpupulong ng kagamitan, pagpupulong ng kagamitan sa elektrisidad, pagmamanupaktura ng mga board ng wire , pagpipinta, hinang, pang-industriya na packaging)",
    em_exam_detail_notify: "Pagkatapos ng pagsusulit, magpadala ng isang abiso sa resulta sa pamamagitan ng email.",
    em_exam_detail_border: "Pagsubok ng kagawaran: 65% o higit pa \n Praktikal na pagsubok: 60 puntos o higit pa",
    ss_exam_detail_language: "Japanese",
    ss_exam_detail_method: "Ang pagsubok sa husay ay isinasagawa ng isang praktikal na pagsubok at isang pagsubok sa kagawaran. \n Ang mga praktikal na pagsusulit ay isinasagawa para sa bawat kategorya ng negosyo. \n Ang pagsubok sa kagawaran ay isinasagawa para sa bawat kategorya ng negosyo sa pamamagitan ng pamamaraang pagsusulit sa papel.",
    ss_exam_detail_way: "Pamamaraan sa pagsubok sa papel, atbp.",
    ss_exam_detail_section: "Kagawaran / Pagsasanay / Mga Kasanayan: Welding, pagpipinta, ironwork, pagtatapos, machining, pagpupulong ng kagamitan sa elektrisidad",
    ss_exam_detail_notify: "-",
    ss_exam_detail_border: "Pagsubok ng kagawaran: 60% o higit pa \n Praktikal na pagsubok: Hatol batay sa praktikal na mga resulta",
    c_exam_detail_language: "Japanese",
    c_exam_detail_method: "Ang pagsubok sa husay ay isinasagawa ng isang praktikal na pagsubok at isang pagsubok sa kagawaran.",
    c_exam_detail_way: "Ang pagsubok na nakabatay sa computer (CBT), praktikal na pagsubok ay isang pamamaraan na tinukoy ng isang nakarehistrong korporasyon",
    c_exam_detail_section: "-",
    c_exam_detail_notify: "Nai-publish sa website",
    c_exam_detail_border: "Pagsubok ng kagawaran: 65% o higit pa \n Praktikal na pagsubok: Hatol batay sa praktikal na mga resulta",
    cm_exam_detail_language: "Japanese",
    cm_exam_detail_method: "Ang pagsubok sa husay ay isinasagawa ng isang praktikal na pagsubok at isang pagsubok sa kagawaran.",
    cm_exam_detail_way: "Magsagawa ng mga pang-akademiko at praktikal na pagsusulit sa pamamagitan ng pagsubok na nakabatay sa computer (CBT)",
    cm_exam_detail_section: "Paksa ng pagsusuri sa paksa \n Elementary na kaalaman tungkol sa istraktura, pag-andar at paraan ng paghawak \n Elementary na kaalaman tungkol sa inspeksyon, pagkumpuni at pagsasaayos \n Elementary na kaalaman tungkol sa istraktura, pagpapaandar at pamamahala ng pamamaraan ng pagsubok na makina, pagsukat ng instrumento at tool para sa pagpapanatili \n Elementary knowledge tungkol sa mga pag-aari at paggamit ng mga materyales at gasolina at taba \nMga praktikal na pagsusulit na paksa \nA Simpleng pangunahing gawain \nB Pagkalas, pagpupulong, simpleng pagsisiyasat at pagsasaayos \nC Madaling pagkumpuni \nD Madaling Pangangasiwa ng mga makina ng pagsubok sa pagpapanatili, mga instrumento sa pagsukat at mga tool.",
    cm_exam_detail_notify: "",
    cm_exam_detail_border: "Pagsubok ng kagawaran: 65% o higit pang Praktikal na pagsubok: Kabuuang iskor na 60% o higit pa",
    a_exam_detail_language: "Lokal na wika at Japanese",
    a_exam_detail_way: "Pagsubok na nakabatay sa computer (CBT), pamamaraan ng pagsubok sa papel",
    a_exam_detail_section: "Ang kagawaran ay nagtaguyod ng agrikultura sa pangkalahatan, kaligtasan at kalusugan, mga pagkakaiba-iba / mga katangian ng mga nilinang pananim, kapaligiran sa paglilinang (pasilidad / kagamitan / materyales / makinarya), pamamaraan ng paglilinang / pamamahala, pagkontrol ng peste / damo, pag-aani / pagsasaayos / pag-iimbak / pagpapadala ②Praktikal na pagmamasid sa lupa, Pangangasiwa ng mga pataba / pestisidyo, paghawak ng mga binhi, pamamahala sa kapaligiran, paghawak ng mga materyales / kagamitan / makina, gawaing nauugnay sa paglilinang, kaligtasan at kalusugan ③ Pakikinig sa mga nilalaman ng gawaing pang-agrikultura na inatasan sa Japanese",
    a_exam_detail_notify: "Nai-publish sa website",
    a_exam_detail_border: "Ang kabuuang iskor ay lumampas sa puntong sanggunian ng paghatol na itinakda ng National Chamber of Agriculture.",
    avi_exam_detail_method: "Ang pagsusulit sa husay ay isinasagawa ng isang praktikal na pagsusulit at isang pagsusulit sa departamento.",
    avi_exam_detail_section: "Ibibigay ang mga katanungan mula sa mga teksto na nai-post sa website ng Japan Aviation Technology Association. Praktikal na konklusyon ng kasanayan, pagsukat ng elektrisidad",
    avi_exam_detail_notify: "",
    avi_exam_detail_border: "Pagsubok ng kagawaran: 65% o higit pang Praktikal na pagsubok: Kabuuang iskor na 65% o higit pa",
    f_exam_detail_language: "Japanese",
    f_exam_detail_method: "Ang pagsubok sa husay ay isinasagawa ng isang praktikal na pagsubok at isang pagsubok sa kagawaran.",
    f_exam_detail_way: "Magsagawa ng mga pang-akademiko at praktikal na pagsusulit sa pamamagitan ng pagsubok na nakabatay sa computer (CBT)",
    f_exam_detail_section: "Ang paksa ng pagsubok ay dapat kumpirmahin na ang isang tiyak na antas ng trabaho sa larangan ng pangisdaan (pangisdaan) o larangan ng pangisdaan (aquaculture) ay maaaring maisagawa nang tumpak sa pamamagitan ng pag-unawa sa mga tagubilin ng superbisor o maaaring isagawa sa sarili nitong paghuhusga, at dalubhasa lamang . Hindi ito isang pagsusuri ng pagkakaroon o kawalan ng kaalaman, ngunit posible ring suriin ang pagkakaroon o kawalan ng wastong paghuhusga at kaalaman sa trabaho na kinakailangan para sa pagsasagawa ng trabaho sa larangan ng pangisdaan (pangisdaan) o larangan ng pangisdaan (aquaculture).",
    f_exam_detail_notify: "Nai-publish sa website",
    f_exam_detail_border: "Ang mga may kabuuang marka ng nakasulat na pagsubok at praktikal na pagsubok ay lumampas sa marka ng pamantayan ng paghatol na itinakda ng ahensya ng pagpapatupad ng husay sa pagsubok ay tinatanggap.",
    no_exam_info: "Wala pang inilabas na impormasyon sa buod ng pagsubok",
    language: "Pagpapatupad ng wika",
    method: "Paraan ng pagpapatupad",
    way: "Paraan ng pagpapatupad",
    section: "Kategoryang Exzmination",
    notify: "Pag-abiso sa mga resulta sa pagsusuri",
    border: "Pamantayan sa resulta ng pagsusuri",
    go_line_at: "Pumila @",
    thank_you_and_deactivate: "Salamat sa paggamit. Para sa pamamaraan para sa pag-alis mula sa serbisyo, mangyaring ipasok ang pamamaraan para sa pag-atras mula sa window ng window @ sa ibaba. Upang kanselahin ang regular na pagbabayad, mangyaring ipasok ang pagkansela ng regular na pagbabayad mula sa line @ window sa ibaba. Isasagawa namin ang pamamaraan sa lalong madaling makakuha kami ng kumpirmasyon.",
    thank_you_and_subscribe: "Salamat sa paggamit. Upang kanselahin ang regular na pagbabayad, mangyaring ipasok ang pagkansela ng regular na pagbabayad mula sa line @ window sa ibaba. \n Kakanselahin namin ang kontrata sa sandaling makatanggap kami ng kumpirmasyon.",
    ten_thousand_yen: "Sampung libong yen",
    yen_per_month: "JPY / buwan",
    how_to_use_this_service: "Daloy ng paggamit",
    selecting_a_browser: "Pagpili ng browser",
    selecting_a_browser_dec: "I-access ang https://aelu.co.jp gamit ang isang browser (Google chrome, Safari, edge, atbp.) * Walang app.",
    provisional_registration: "Pansamantalang pagpaparehistro",
    provisional_registration_dec: "Mag-log in gamit ang iyong Facebook o Google ID o magparehistro sa iyong email address. Matapos mapili ang nais na wika at nais na trabaho, maaari kang mag-browse sa nilalamang online na pagsusulit sa pagsusulit sa sertipikasyon.",
    full_registration: "Pangunahing pagpaparehistro",
    full_registration_dec: "I-click ang Pangunahing Pagpaparehistro sa pahina ng nilalaman ng pagsusulit sa sertipikasyon sa online, punan ang kinakailangang impormasyon, at gamitin ang lahat ng mga serbisyo kasama ang 14 na katanungan sa kasanayan sa pagsusulit sa sertipikasyon sa industriya.",
    name_validate_message: "Mangyaring ipasok ang impormasyon na may parehong spelling tulad ng paglitaw nito sa iyong pasaporte.",
    live_at_area: "Lugar kung saan ka kasalukuyang nakatira",
    agency_application: "Kumikilos para sa aplikasyon ng pagsusulit",
    mypage: "Aking pahina",
    myanmar: "Burmese",
    exam_list: "Listahan ng iskedyul ng pagsusuri",
    no: "Hindi.",
    times: "Mga oras",
    application_start: "Simulan ang application",
    application_end: "Ang deadline ng aplikasyon",
    enforcement: "Pagpapatupad",
    applicated: "Inilapat",
    reception_time: "Oras ng pagtanggap",
    announthment_d: "Petsa ng anunsyo ng pagtanggap",
    reception_period: "Panahon ng aplikasyon",
    detail_link: "suriin ang mga detalye",
    exam_country: "Bansang host",
    line: "LINE",
    vietnum: "Vietnam",
    laos: "Laos",
    malaysia: "Malaysia",
    bangladesh: "Bangladesh",
    indo: "India",
    nepal: "Nepal",
    mongol: "Mongolia",
    indonesia: "Indonesia",
    th: "Thailand",
    philipine: "Pilipinas",
    my: "Myanmar",
    uzbekistan: "Uzbekistan",
    pakistan: "Pakistan",
    japan: "Hapon",
    news_title: "Balita tungkol sa mga tiyak na visa ng kasanayan",
    missNowPassword: "Ang kasalukuyang password ay hindi tama",
    article6_sub2_dec2: "Kung mag-a-apply ka dito, ipapahayag din namin ang application ng pagsusulit, ang presyo ng exm, at ang venue hanggang sa araw ng pagsusulit.",
    create_naw_password: "palitan ANG password",
    send_confirmcode: "Isang verification code ang naipadala",
    edit: "magbago",
    success_new_password_setting: "Nagtakda ka ng isang bagong password.",
    error_email: "Ito ay isang hindi nakarehistrong email address.",

    click_here_businesses: "Mag-click dito para sa mga negosyo",
    regist_organization_staff_info: "Pagrehistro ng impormasyon ng negosyo / gumagamit",
    organization_info: "Impormasyon ng negosyo",
    staff_info: "Impormasyon ng Gumagamit",
    org_name: "Pangalan ng Negosyo",
    url: "URL",
    org_scale: "sukatan",
    org_zip: "Postal code",
    org_adress1: "Mga prefecture",
    org_adress2: "Munisipalidad",
    org_adress3: "Address / Pangalan ng apartment",
    org_industry: "Industriya",
    org_category: "Kategorya",
    org_description: "Paglalarawan",
    org_established_at: "Taon ng pagtatatag",
    org_phone: "Numero ng telepono sa negosyo",
    failed_established_at: "Maling petsa.",
    staff_name: "username",
    form_miss: "Mayroong pagkakamali sa input form.",
    back_joboffer_detail: "Bumalik sa mga detalye sa trabaho <",
    create_joboffer: "Lumikha ng trabaho",
    edit_joboffer: "I-edit ang Trabaho",
    stop_posting: "Ihinto ang pag-post",
    delete: "tanggalin",
    job_title: "Titulo sa trabaho",
    job_catch_phrase: "Parirala ng catch ng trabaho",
    job_category: "Kategorya ng trabaho",
    employed_company_name: "Pangangalakal na pangalan ng kumpanya",
    work_location: "Lokasyon ng trabaho",
    employment_status: "Katayuan sa trabaho",
    full_time_employee: "Full time na empleyado",
    part_time_job: "part-time na trabaho",
    temporary_staff: "Nagpadala ng paggawa",
    contract_employee: "Empleyado ng kontrata",
    intern: "Intern",
    subcontracting: "Pagsusulit",
    contract: "Kontrata",
    new_graduate: "Bagong nagtapos",
    salary: "Sweldo",
    annual_income: "taunang kita",
    monthly_salary: "Buwanang suweldo",
    weekly_salary: "Lingguhang suweldo",
    dayly_salary: "Pang-araw-araw na suweldo",
    job_offer_attension1: "Kinakailangan na malinaw na ipahiwatig ang iniresetang mga kondisyon sa pagtatrabaho, atbp. Para sa nilalaman ng trabaho alinsunod sa batas.",
    job_offer_attension2: "Mangyaring suriin ang mga kundisyon sa pagtatrabaho, atbp. Na kinakailangang malinaw na isinaad ng batas, at pagkatapos ay ilarawan ang nilalaman ng trabaho. (Sanggunian: Ministry of Health, Labor and Welfare, Prefectural Labor Bureau &quot;Sa lahat ng mga kumpanya na nagrekrut ng mga manggagawa&quot;)",
    job_offer_attension3: "Ang mga trabaho ay maaaring hindi mai-post kung gumagamit ka ng wika na naglilimita sa edad, kasarian, o katayuan sa panlipunan ng target na tao.",
    job_offer_attension4: "Madalas na hindi nai-publish na mga halimbawa: &quot;Maligayang pagdating sa 20s&quot; &quot;Maligayang pagdating sa mga kabataan (kabataan)&quot; &quot;Maligayang pagdating / limitado ang mga kababaihan&quot; &quot;Mga mag-aaral lamang&quot;",
    work_content_appeal: "Nilalaman ng trabaho at mga puntos ng pag-apela",
    work_content_appeal_desc: "Mas madali para sa mga naghahanap ng trabaho na maging interesado kung sasabihin mo sa kanila ang mga puntos ng apela.",
    human_resources_seek: "Mga mapagkukunan ng tao",
    human_resources_seek_desc: "Iparating natin hindi lamang ang mga kasanayang hinahanap mo, kundi pati na rin ang impormasyon na nagpapahintulot sa mga naghahanap ng trabaho na isipin ang lugar ng trabaho.",
    working_hours: "Oras ng trabaho",
    traffic_access: "Pag-access sa trapiko",
    traffic_access_desc: "Bilang karagdagan sa impormasyon sa pampublikong transportasyon, isama ang impormasyon tulad ng pag-commute sa pamamagitan ng kotse at kung mayroong isang paradahan para sa mga empleyado.",
    required: "Sapilitan",
    optional: "Kahit ano",
    other: "Iba pa",
    photo: "Larawan",
    upload_video: "Mag-upload ng video",
    job_tag: "Mga tag ng trabaho",
    until_select_three: "Hanggang 3 ang maaaring mapili",
    senior_support: "Senior na suporta",
    salary_increase_promotion: "May pagtaas / promosyon sa suweldo",
    no_overtime: "Walang obertaym",
    target_hiring_time: "Target na oras ng pagkuha",
    additional_questions: "Karagdagang tanong",
    job_offer_title: "Pangalan ng trabaho",
    public: "Pakawalan",
    private: "pribado",
    public_status: "Katayuan sa publiko",
    occupation: "Trabaho",
    walfare: "Paggamot / kapakanan",
    create: "lumikha",
    hour: "Oras",
    back_mypage: "Bumalik sa Aking Pahina <",
    job_offers: "Listahan ng trabaho",
    look_matches: "Tingnan ang listahan ng tugma",
    now_public: "Bukas na",
    now_private: "Pribado",
    check: "Kumpirmahin",
    edit2: "Upang i-edit",
    news_detail: "Mga detalye ng balita",
    prefectures: "Mga prefecture",
    hokkaido: "Hokkaido",
    aomori: "Aomori",
    iwate: "Iwate",
    miyagi: "Miyagi",
    akita: "Akita",
    yamagata: "Yamagata",
    fukushima: "Fukushima",
    ibaraki: "Ibaraki",
    tochigi: "Tochigi",
    gunma: "Gunma",
    saitama: "Saitama",
    chiba: "Chiba",
    tokyo: "Tokyo",
    kanagawa: "Kanagawa",
    niigata: "Niigata",
    toyama: "Toyama",
    ishikawa: "Ishikawa",
    fukui: "Fukui",
    yamanashi: "Yamanashi",
    nagano: "Nagano",
    gifu: "Gifu",
    shizuoka: "Shizuoka",
    aichi: "Si Aichi",
    mie: "Triple",
    shiga: "Shiga",
    kyoto: "Kyoto",
    osaka: "Osaka",
    hyogo: "Hyogo",
    nara: "Nara",
    wakayama: "Wakayama",
    tottori: "Tottori",
    shimane: "Si Shimane",
    okayama: "Okayama",
    hiroshima: "Hiroshima",
    yamaguti: "Yamaguchi",
    tokushima: "Tokushima",
    kagawa: "Kagawa",
    echime: "Ehime",
    kochi: "Kochi",
    fukuoka: "Fukuoka",
    saga: "Saga",
    nagasaki: "Nagasaki",
    kumamoto: "Kumamoto",
    oita: "Oita",
    miyazaki: "Miyazaki",
    kagoshima: "Kagoshima",
    okinawa: "Okinawa",
    sinhalese: "Sinhala",
    exam_region: "Mga prefecture",
    exam_place_list: "Listahan ng Venue",
    exam_place_name: "Pangalan ng venue ng eksaminasyon",
    care_evaluation_test: "Pang-matagalang pagsubok sa pagsusuri ng kasanayan sa kasanayan sa pangangalaga",
    clean_building_test: "Ang industriya ng paglilinis ng gusali ay nagdaang mga problema",
    answer: "sagot",
    skill_test_measurement: "Pagsusulit sa pagsusukat ng kasanayan",
    exam_problem: "tanong ng pagsusulit",
    fields: "Mga bukirin at gulay",
    gardening: "Paghahardin sa pasilidad",
    mushroom: "kabute",
    fruit: "Puno ng prutas",
    dairy: "pagawaan ng gatas",
    poultry: "Pagsasaka ng manok",
    pig: "Pagsasaka ng baboy",
    beginner: "Nagsisimula",
    professional: "Marka ng propesyonal",
    advanced: "Advanced",
    technical_training_test: "Pagsusulit sa pagsusuri sa pagsusuri ng pagsasanay sa teknikal",
    exam_part: "Bahagi ng mga katanungan sa pagsusulit",
    tokoha_fruit: "Tokoha na puno ng prutas",
    deciduous_fruit: "Nangungulag puno ng prutas",
    ver: "Edisyon",
    errata: "errata",
    form_work: "Pagtatayo ng formwork",
    construction: "Plasterer",
    tunnel_line: "Linya ng paggalaw ng lagusan",
    earth_work: "Gawaing lupa",
    loofing: "Pang-bubong",
    elecommunication: "telecommunication",
    reinforcing_contstruction: "Reinforcing konstruksyon ng bar",
    reinforcing_joint: "Reinforcing bar joint",
    wall_painting: "Pagpipinta (pantakip sa dingding)",
    board_finish: "Tapos ng board, tapusin ang panloob",
    steeplejack: "Tumalon",
    spray_insulation: "Spray na pagkakabukod ng urethane",
    marine_civil: "Marine civil engineering",
    concrete_pumping: "Konkreto na pagbomba",
    construction_machinery: "Konstruksiyon ng makinarya sa konstruksyon",
    learning_text: "Pag-aaral ng teksto",
    basic_aircraft: "Pagtatapos ng pangunahing teknolohiya ng sasakyang panghimpapawid, pagsukat ng elektrisidad",
    worksafety_quality: "Kaligtasan sa trabaho, kalidad",
    aircraft_overview: "Pangkalahatang-ideya ng sasakyang panghimpapawid",
    fish_general: "Pangingisda sa pangkalahatan",
    fish_safety: "Kaligtasan ng pangisdaan",
    network_relations: "Pakikipag-ugnay sa specialty ng lubid",
    fish_relations: "Kaugnay ng pangingisda sa pangingisda",
    aquaculture_general: "Aquaculture sa pangkalahatan",
    feeding_aquaculture: "Espesyalidad sa aquaculture Pagpapakain ng aquaculture",
    unfed_aquaculture: "Espesyalidad sa aquaculture Unfed aquaculture",
    attachment: "Kalakip",
    glossary: "Talasalitaan",
    feneral_customer: "Pangkalahatang serbisyo sa customer",
    food_dring_cooking: "Pagluluto ng pagkain at inumin",
    hygiene_management: "pamamahala sa kalinisan",
    visa_application: "Tukoy na aplikasyon ng kasanayan visa",
    certificate_residence_tax: "1. Sertipiko ng buwis sa paninirahan (para sa huling taon)",
    salary_income_withholding : "2. Isang kopya ng withholding slip para sa kita sa suweldo",
    national_health_insured: "3. Isang kopya ng kard ng taong nakaseguro sa Pangkalusugan na Seguro (kung ang tao ay na-enrol)",
    national_health_payment: "4. National Health Insurance Premium Payment Certificate",
    national_health_receipt: "5. Isang kopya ng resibo ng premium ng National Health Insurance",
    technical_intern_training2: "6. Mga dokumento na nagpapatunay na ang pagsasanay sa teknikal na pagsasanay Blg. 2 ay matagumpay na nakumpleto",
    need_the_following : "Kailangan mo ng isa sa mga sumusunod:",
    pass_certificate_test_specialized : "· Isang kopya ng pass sertipiko ng praktikal na pagsubok sa kasanayan ng pagsubok sa pagsusuri ng kasanayan (dalubhasang marka)",
    technical_intern_training3: "· Isang kopya ng pass sertipiko ng praktikal na pagsubok ng kasanayan sa pagsubok (ika-3 baitang)",
    evaluation_record_technical_intern: "· Kung hindi ka nakapasa sa pagsusulit sa itaas, kailangan mong punan ang tala ng pagsusuri para sa trainee ng teknikal na intern.",
    cartificate_pass_basic_test: "Bilang kahalili sa 7.6, maaari kang magsumite ng isang kopya ng sertipiko ng pass ng Japan Foundation Japanese Basic Test o isang kopya ng pass sertipiko ng Japanese Language Proficiency Test (N4) o mas mataas.",
    change_permission_application: "8. Larawan ng aplikasyon ng pahintulot sa pagbabago (patayong 4 cm x pahalang 3 cm)",
    resume_data_time_entry: "9. Ipagpatuloy ang data sa oras ng pagpasok",
    select_file: "Pumili ng mga file",

    description_movie: "Video ng paliwanag",
    how_to_use_movie: "Paano gumamit ng video",
    movie_news: "1. Balita tungkol sa mga tiyak na visa ng kasanayan",
    movie_exam: "2. Bilang ng mga araw na natitira hanggang sa petsa ng pagsubok",
    movie_predict_pass: "3. Tinantyang rate ng pass",
    movie_ave_study_test: "4. Average na marka ng iyong sariling pagsubok na iyong pinag-aralan",
    movie_similar_exam: "5. Katulad na mga katanungan sa pagsusulit",
    movie_learning_text: "6. I-download ang libro sa pag-aaral (aklat)",
    movie_solved_exam: "7. Mga problemang nalutas ko sa nakaraan",
    movie_pased_exam: "8. Tungkol sa pagkakita ng mga nakaraang problema na talagang lumitaw",
    movie_resume_regist: "9. Ipagpatuloy ang pagpaparehistro sa oras ng pagpasok",
    movie_pass_document_regist: "10. Pagpaparehistro ng pass prof test",
    movie_agency_service: "11. Serbisyong ahensya ng aplikasyon ng pagsusulit",
    movie_consule_service: "12. Serbisyo sa konsultasyon sa pag-aaral",
    description_movie_trans: "Kung nais mong manuod sa isang wika maliban sa Japanese, i-click ang marka ng gear, i-click ang mga subtitle at awtomatikong pagsasalin, piliin ang iyong katutubong wika, at pagkatapos ay panoorin.",


    "cultivated_agriculture_general": "Nilinang agrikultura sa pangkalahatan",
    "livestock_agriculture": "Pag-aalaga ng hayop",
    "介護": "pag-aalaga",
    "ビルクリーニング": "Paglilinis ng gusali",
    "建設": "pagtatayo",
    "自動車整備": "Pagpapanatili ng sasakyan",
    "航空業": "Industriyang panghimpapawid",
    "農業": "Agrikultura",
    "漁業": "Pangingisda",
    "飲食料品製造業": "Industriya ng paggawa ng pagkain at inumin",
    "外食業": "Negosyo sa restawran",
    "型枠施工": "Paggawa ng formwork",
    "左官": "Plasterer",
    "コンクリート圧送": "Concrete pumping",
    "トンネル推進工": "Trabaho ng tunnel propulsion",
    "建設機械施工": "Konstruksyon ng makinarya sa konstruksyon",
    "大工": "karpintero",
    "屋根ふき": "Pagbububong",
    "電気通信": "telekomunikasyon",
    "鉄筋施工": "Pagpapatibay ng pagtatayo ng bar",
    "鉄筋継手": "Reinforcing bar joint",
    "壁装（壁張り）": "Panakip sa dingding (takip sa dingding)",
    "ボード仕上げ、内装仕上げ": "Board finish, interior finish",
    "とび": "Tumalon",
    "吹き付けウレタン断熱": "Sprayed firing insulation",
    "海洋土木工": "Marine civil engineering",
    "航空機の基本技術 締結、電気計測": "Sasakyang panghimpapawid pangunahing teknolohiya konklusyon, electrical pagsukat",
    "作業安全、品質": "Kaligtasan sa trabaho, kalidad",
    "航空機概要": "Pangkalahatang-ideya ng sasakyang panghimpapawid",
    "耕種農業全般": "Nilinang agrikultura sa pangkalahatan",
    "畜産農業": "Pag-aalaga ng hayop",
    "漁業一般": "Pangingisda sa pangkalahatan",
    "漁業安全": "Kaligtasan sa pangingisda",
    "漁業専門 綱関係": "Mga relasyong lubid sa espesyalidad ng pangisdaan",
    "漁業専門 釣り関係": "Dalubhasa sa pangingisda na may kaugnayan sa pangingisda",
    "養殖業一般": "Aquaculture sa pangkalahatan",
    "養殖業専門 給餌養殖関係": "Espesyalidad sa Aquaculture Pagpapakain ng aquaculture",
    "養殖業専門 無給餌養殖関係": "Espesyalidad sa Aquaculture Unfed aquaculture",
    "接客全般": "Pangkalahatang serbisyo sa customer",
    "飲食物調理": "Pagluluto ng pagkain at inumin",
    "衛生管理": "pamamahala sa kalinisan",
    "日本語版": "Japanese version",
    "英語版": "English na edisyon",
    "クメール語版": "bersyon ng Khmer",
    "インドネシア語版": "bersyong Indonesian",
    "インドネシア語・正誤表": "Pagkakamali ng Indonesian",
    "ネパール語版": "bersyon ng Nepali",
    "モンゴル語版": "bersyon ng Mongolian",
    "ビルマ語版": "Bersyon ng Burmese",
    "ベトナム語版": "bersyong Vietnamese",
    "タイ語版": "bersyon ng Thai",
    "テキスト１": "Teksto 1",
    "テキスト２": "Teksto 2",
    "テキスト３": "Teksto 3",
    "テキスト４": "Teksto 4",
    "テキスト５": "Teksto 5",
    "ミャンマー(ビルマ)語版": "bersyon ng wikang Myanmar (Burmese).",
    "カンボジア(クメール)語版": "bersyon ng wikang Cambodia (Khmer).",
    "ミャンマー語版": "Bersyon ng Burmese",
    "中国語版": "Tsinong bersyon",
    "付属資料": "Kalakip",
    "用語集": "Talasalitaan",

    invitation_code: "Code ng imbitasyon",
exam_calender: "Kalendaryo ng iskedyul ng pagsusulit",
move_exam_detail: "Gusto mo bang pumunta sa pahina ng mga detalye ng iskedyul ng pagsusulit?",
move: "Gumagalaw",
plece_select_language: "Mangyaring pumili ng isang wika",
select: "pumili",
midle_category: "hanapbuhay",
select_industry_description: "Sa simula, ang AELU ay maaari lamang pumili ng hanggang 3 industriya, kaya piliin lamang ang industriya na gusto mong pagtrabahuhan. Kung masaya ka dito, pindutin ang Susunod",
done_member_regist_description_2: "Mula ngayon, susuportahan namin ang AELU upang makakuha ng partikular na skill visa sa pamamagitan ng paghahanda ng maraming pagsusulit sa sertipikasyon.",
done_member_regist_2: "Kumpleto na ang pagpaparehistro ng miyembro.",
is_exist_user: "Mayroon nang user na may parehong email address.",
invitation_code_description: "(Pakilagay ang invitation code mula sa nagpapadalang organisasyon o Japanese language school, kung hindi ay lalabas ang expense settlement screen, kaya huwag kalimutang ilagay ito.)",
pleace_select_region: "Mangyaring piliin ang host prefecture",
pleace_add_messenger: "Ang lahat ng mga contact ay ipapadala sa pamamagitan ng Facebook messager kaya siguraduhing idagdag ang mga ito",
add_messenger_bot: "Tumanggap ng mga abiso",
visa_application_description: "Kinakailangan ang lokasyon ng pag-iimbak ng dokumento kapag nag-aaplay para sa isang partikular na visa ng kasanayan",
check_agree: "Mangyaring sumang-ayon",
sample_title: "Ito ay isang dummy na pamagat. Mangyaring itakda",
sample_description: "Ito ay isang dummy paglalarawan. Mangyaring itakda. Ito ay isang dummy paglalarawan. Mangyaring itakda. Ito ay isang dummy paglalarawan. Mangyaring itakda. Ito ay isang dummy paglalarawan. Mangyaring itakda. Ito ay isang dummy paglalarawan. Mangyaring itakda. Ito ay isang dummy paglalarawan. Mangyaring itakda. Ito ay isang dummy paglalarawan. Mangyaring itakda.",
create_profile_error: "May error sa input. Pakisuri ang item",
setting_confirm: "Mangyaring kumpirmahin ang mga nilalaman ng input at magparehistro",
exam_learning: "Pag-aaral ng pagsusulit",
recommend_problem_solve: "Lutasin ang mga katulad na tanong sa pagsusulit",
of: "ng",
see_solved_problem: "Lutasin ang mga problemang nalutas mo sa nakaraan \ n",
past_exam_collection: "\ N mga tanong sa pagsusulit na lumitaw sa nakaraan",
any_application_registration: "Iba&#39;t ibang pagpaparehistro ng aplikasyon",
mypage_visa_application: "Partikular na kasanayan sa visa \ n aplikasyon",
applyt_exam_and_agent: "Application ng pagsusulit \ n Application ng serbisyo ng proxy",
myapge_regist_accept_certificate: "Pagsusulit sa kasanayan \ nPagpaparehistro ng pass",
mypage_consultaion_service: "Serbisyong konsultasyon sa pag-aaral",
consult: "Kumonsulta",
of_exam_day: "Petsa ng pagsubok",
your_ave_score: "Average na marka para sa iyong \ n pagsubok",
your_estimated_pass_rate: "Ang iyong tinantyang pass rate",
your_ave_score_fotter: "Average na marka para sa iyong pagsusulit",
your_estimated_pass_rate_fotter: "Tinantyang pass rate",
mypage_study_text: "I-download ang aklat-aralin sa pag-aaral \ n",
exam_schedule: "Iskedyul ng pagsusulit",
resident_caption_title: "● Tungkol sa pag-upload ng residence card o ID card",
resident_caption: "Mangyaring mag-upload ng residence card o ID card na maaaring kumpirmahin ang impormasyon sa pulang frame. \ nMangyaring mag-upload ng wastong residence card o ID card na hindi pa nag-expire. \ nMag-upload ng larawang may kulay sa format na PDF o JPG.",
password_caption_title: "● Tungkol sa pag-upload ng mga password",
password_caption: "Mangyaring mag-upload ng larawan ng pasaporte na nagpapatunay sa iyong pangalan / larawan / natatanging numero / petsa ng kapanganakan / nasyonalidad / petsa ng pag-expire tulad ng ipinapakita sa pulang frame. \ nMangyaring mag-upload ng wastong pasaporte na hindi pa nag-expire. \ nMag-upload ng larawang may kulay sa format na PDF o JPG.",
title_help: "tulong",
step3_title_help: "Mangyaring ipasok ang iyong impormasyon nang tama.",
lineid_input_help: "Buksan ang LINE → Home → Settings → Profile → Mag-scroll para makita ang ID. Pakilagay ang ID na iyon. Kung hindi mo pa ito nilikha, mangyaring likhain ito at ilagay ito.",
country_input_help: "Mangyaring piliin ang bansa ng iyong nasyonalidad.",
area_input_help: "Piliin ang bansa ng iyong lugar kung saan ka kasalukuyang nakatira.",
phone_input_help: "Pakibigay na lng po ng phone number niyo.",
issuing_input_help: "Mangyaring piliin ang lugar kung saan ibinigay ang iyong ID.",
idtype_input_help: "Mangyaring pumili ng uri ng ID. Mangyaring kumuha ng magandang larawan ng napiling tao at i-upload ito. Mangyaring i-shoot nang diretso upang walang mga diagonal o cut point.",
invitation_input_help: "Kung mayroon kang code ng imbitasyon, ilagay ito.",
exam_menu_help: "Magkakaroon ng mga tanong na katulad ng mga tanong na talagang tinanong sa nakaraan. Lutasin ang mga paulit-ulit na tanong upang maghanda para sa pagsusulit.",
past_menu_help: "Magkakaroon ka ng mga problema na nalutas mo sa nakaraan. Suriin natin ang mga pagkakamali.",
pastexam_menu_help: "Ito ang teksto ng mga tanong sa pagsusulit na talagang umiral sa nakaraan.",
text_menu_help: "Maaari mong tingnan ang mga aklat-aralin sa pag-aaral upang pag-aralan ang mahahalagang punto at malaman kung ano ang hindi mo naiintindihan.",
visa_menu_help: "Tutulungan ka naming makakuha ng isang partikular na skill visa. Kung gusto mong makakuha ng visa para sa isang partikular na kasanayan, mangyaring mag-apply dito.",
agency_menu_help: "Mag-a-apply kami para sa partikular na pagsubok sa kasanayan sa ngalan mo. Kung gusto mong kumuha ng partikular na pagsusulit sa kasanayan, mangyaring mag-apply dito.",
cer_menu_help: "Kung kumuha ka ng partikular na pagsusulit sa kasanayan at may sertipiko ng pagpasa, mangyaring magparehistro dito.",
service_menu_help: "Kung mayroon kang anumang mga katanungan o alalahanin, mangyaring makipag-ugnay sa amin sa pamamagitan ng chat dito.",
occu_title_help: "Mangyaring pumili ng hanggang 3 gustong trabaho.",
back: "bumalik",
before: "Sa nakaraang problema",
srilank: "Sri Lanka",
reselect: "Kung gusto mong baguhin ang file, pindutin muli ang &quot;I-upload ang iyong pasaporte&quot; at piliin muli",
iphone_file: "Para sa iphone, mangyaring gamitin pagkatapos i-convert mula sa HEIC file sa JPG file.",
file_transmit: "I-convert ang mga file",
combodia: 'combodia',
}
